/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FeedSchedulerInputQueryVariables = {
    queryInput: string;
    orgRelayId: string;
    excludeCalendars?: Array<string | null> | null | undefined;
    emails: Array<string>;
    externalGroupRefetch: boolean;
    teamId: string;
    teamAttendeesRefetch: boolean;
};
export type FeedSchedulerInputQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"FeedSchedulerInput_viewer">;
    };
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"FeedSchedulerInput_org">;
    } | null;
};
export type FeedSchedulerInputQuery = {
    readonly response: FeedSchedulerInputQueryResponse;
    readonly variables: FeedSchedulerInputQueryVariables;
};



/*
query FeedSchedulerInputQuery(
  $queryInput: String!
  $orgRelayId: ID!
  $excludeCalendars: [String]
  $emails: [String!]!
  $externalGroupRefetch: Boolean!
  $teamId: String!
  $teamAttendeesRefetch: Boolean!
) {
  viewer {
    ...FeedSchedulerInput_viewer_3KHshA
    id
  }
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...FeedSchedulerInput_org_1UULpr
    }
    id
  }
}

fragment FeedSchedulerInput_org_1UULpr on Org {
  id
  externalGroups(emails: $emails) @include(if: $externalGroupRefetch) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on ExternalGroupList {
      list {
        email
        memberEmails
        id
      }
    }
  }
  teamForTeamId(teamId: $teamId) @include(if: $teamAttendeesRefetch) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Team {
      teamId
      teamName
      teamMembers {
        person {
          primaryCalendarId
          isYou
          profile {
            givenName
            familyName
            externalImageUrl
          }
          id
        }
      }
      invitedMembers {
        person {
          primaryCalendarId
          isYou
          profile {
            givenName
            familyName
            externalImageUrl
          }
          id
        }
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment FeedSchedulerInput_viewer_3KHshA on Viewer {
  personQueryResultErrorable(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) @skip(if: $externalGroupRefetch) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on PersonQueryResult {
      query
      persons {
        id
        primaryEmail
        emails
        profile {
          givenName
          familyName
          externalImageUrl
        }
      }
    }
  }
  groupQueryResult(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) @skip(if: $externalGroupRefetch) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on ExternalGroupSearchResult {
      inputQuery
      groups {
        emailAddress
        groupSize
      }
    }
  }
  teamQueryResultErrorable(query: $queryInput, orgRelayId: $orgRelayId) @skip(if: $externalGroupRefetch) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on TeamQueryResult {
      query
      teams {
        teamName
        teamId
        teamRoleAndPersonIds {
          role
          personId
        }
        id
      }
      teamMembers {
        role
        person {
          personId
          isYou
          primaryCalendarId
          profile {
            givenName
            familyName
            externalImageUrl
          }
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emails"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeCalendars"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalGroupRefetch"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryInput"
    } as any, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamAttendeesRefetch"
    } as any, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamId"
    } as any, v7 = {
        "kind": "Variable",
        "name": "excludeCalendars",
        "variableName": "excludeCalendars"
    } as any, v8 = {
        "kind": "Variable",
        "name": "externalGroupRefetch",
        "variableName": "externalGroupRefetch"
    } as any, v9 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v10 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v11 = {
        "kind": "Variable",
        "name": "emails",
        "variableName": "emails"
    } as any, v12 = {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v14 = {
        "kind": "Variable",
        "name": "query",
        "variableName": "queryInput"
    } as any, v15 = [
        (v7 /*: any*/),
        (v9 /*: any*/),
        (v14 /*: any*/)
    ], v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "query",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamName",
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v26 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                (v25 /*: any*/),
                (v24 /*: any*/),
                (v19 /*: any*/),
                (v13 /*: any*/)
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/),
                (v6 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "FeedSchedulerInputQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                (v7 /*: any*/),
                                (v8 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "queryInput",
                                    "variableName": "queryInput"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "FeedSchedulerInput_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v10 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": [
                                        (v11 /*: any*/),
                                        (v8 /*: any*/),
                                        {
                                            "kind": "Variable",
                                            "name": "teamAttendeesRefetch",
                                            "variableName": "teamAttendeesRefetch"
                                        },
                                        (v12 /*: any*/)
                                    ],
                                    "kind": "FragmentSpread",
                                    "name": "FeedSchedulerInput_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v4 /*: any*/),
                (v3 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/),
                (v2 /*: any*/),
                (v6 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "Operation",
            "name": "FeedSchedulerInputQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v13 /*: any*/),
                        {
                            "condition": "externalGroupRefetch",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v15 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personQueryResultErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v16 /*: any*/),
                                        (v17 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v18 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Person",
                                                    "kind": "LinkedField",
                                                    "name": "persons",
                                                    "plural": true,
                                                    "selections": [
                                                        (v13 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "emails",
                                                            "storageKey": null
                                                        },
                                                        (v19 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "PersonQueryResult",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v15 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "groupQueryResult",
                                    "plural": false,
                                    "selections": [
                                        (v16 /*: any*/),
                                        (v17 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "inputQuery",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ExternalGroupSearchMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "emailAddress",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "groupSize",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "ExternalGroupSearchResult",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        (v9 /*: any*/),
                                        (v14 /*: any*/)
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "teamQueryResultErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v16 /*: any*/),
                                        (v17 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v18 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Team",
                                                    "kind": "LinkedField",
                                                    "name": "teams",
                                                    "plural": true,
                                                    "selections": [
                                                        (v20 /*: any*/),
                                                        (v21 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamRoleAndPersonId",
                                                            "kind": "LinkedField",
                                                            "name": "teamRoleAndPersonIds",
                                                            "plural": true,
                                                            "selections": [
                                                                (v22 /*: any*/),
                                                                (v23 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v13 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TeamMember",
                                                    "kind": "LinkedField",
                                                    "name": "teamMembers",
                                                    "plural": true,
                                                    "selections": [
                                                        (v22 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "OrgPerson",
                                                            "kind": "LinkedField",
                                                            "name": "person",
                                                            "plural": false,
                                                            "selections": [
                                                                (v23 /*: any*/),
                                                                (v24 /*: any*/),
                                                                (v25 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v13 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TeamQueryResult",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ]
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v10 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v16 /*: any*/),
                        (v13 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "condition": "externalGroupRefetch",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": [
                                                (v11 /*: any*/)
                                            ],
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "externalGroups",
                                            "plural": false,
                                            "selections": [
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ExternalGroup",
                                                            "kind": "LinkedField",
                                                            "name": "list",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "email",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "memberEmails",
                                                                    "storageKey": null
                                                                },
                                                                (v13 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "ExternalGroupList",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "condition": "teamAttendeesRefetch",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": [
                                                (v12 /*: any*/)
                                            ],
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "teamForTeamId",
                                            "plural": false,
                                            "selections": [
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        (v21 /*: any*/),
                                                        (v20 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamMember",
                                                            "kind": "LinkedField",
                                                            "name": "teamMembers",
                                                            "plural": true,
                                                            "selections": (v26 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamMember",
                                                            "kind": "LinkedField",
                                                            "name": "invitedMembers",
                                                            "plural": true,
                                                            "selections": (v26 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "Team",
                                                    "abstractKey": null
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        (v13 /*: any*/)
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "288921ce81b98cf8ab800381464ad122",
            "id": null,
            "metadata": {},
            "name": "FeedSchedulerInputQuery",
            "operationKind": "query",
            "text": "query FeedSchedulerInputQuery(\n  $queryInput: String!\n  $orgRelayId: ID!\n  $excludeCalendars: [String]\n  $emails: [String!]!\n  $externalGroupRefetch: Boolean!\n  $teamId: String!\n  $teamAttendeesRefetch: Boolean!\n) {\n  viewer {\n    ...FeedSchedulerInput_viewer_3KHshA\n    id\n  }\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...FeedSchedulerInput_org_1UULpr\n    }\n    id\n  }\n}\n\nfragment FeedSchedulerInput_org_1UULpr on Org {\n  id\n  externalGroups(emails: $emails) @include(if: $externalGroupRefetch) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on ExternalGroupList {\n      list {\n        email\n        memberEmails\n        id\n      }\n    }\n  }\n  teamForTeamId(teamId: $teamId) @include(if: $teamAttendeesRefetch) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Team {\n      teamId\n      teamName\n      teamMembers {\n        person {\n          primaryCalendarId\n          isYou\n          profile {\n            givenName\n            familyName\n            externalImageUrl\n          }\n          id\n        }\n      }\n      invitedMembers {\n        person {\n          primaryCalendarId\n          isYou\n          profile {\n            givenName\n            familyName\n            externalImageUrl\n          }\n          id\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment FeedSchedulerInput_viewer_3KHshA on Viewer {\n  personQueryResultErrorable(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) @skip(if: $externalGroupRefetch) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on PersonQueryResult {\n      query\n      persons {\n        id\n        primaryEmail\n        emails\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n      }\n    }\n  }\n  groupQueryResult(query: $queryInput, orgRelayId: $orgRelayId, excludeCalendars: $excludeCalendars) @skip(if: $externalGroupRefetch) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on ExternalGroupSearchResult {\n      inputQuery\n      groups {\n        emailAddress\n        groupSize\n      }\n    }\n  }\n  teamQueryResultErrorable(query: $queryInput, orgRelayId: $orgRelayId) @skip(if: $externalGroupRefetch) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on TeamQueryResult {\n      query\n      teams {\n        teamName\n        teamId\n        teamRoleAndPersonIds {\n          role\n          personId\n        }\n        id\n      }\n      teamMembers {\n        role\n        person {\n          personId\n          isYou\n          primaryCalendarId\n          profile {\n            givenName\n            familyName\n            externalImageUrl\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '49191e6d39c2b9ee2a1e731b3503079d';
export default node;
